import { useTheme } from 'styled-components'
import { TodistusTheme } from 'todistukset-ui/src/vtj/todistus-theme'

export const useTodistusTheme = (): TodistusTheme => {
  const theme = useTheme()
  return theme as TodistusTheme
}
